import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '../loader/loader.service';

@Component({
  selector: 'app-fale-conosco-dialog',
  templateUrl: './fale-conosco-dialog.component.html',
  styleUrls: ['./fale-conosco-dialog.component.scss']
})
export class FaleConoscoDialogComponent implements OnInit {

  iframeSrc: string;
  linkMovidesk: string = environment.urlCentralAtendimento;
  modalFullscreen?: boolean = false


  constructor(private _activeModal: NgbActiveModal,
    private _loaderService: LoaderService
  ) { }

  ngOnInit() {
    this._loaderService.show('Carregando...');
    this.acessarPagina();
  }

  acessarPagina() {
    this.iframeSrc = this.linkMovidesk;
  }

  close() {
    this._activeModal.close();
  }

  setFullScreen() {
    const el = document.getElementsByClassName('modal-content')[0]
    if (!el) return

    this.modalFullscreen = !this.modalFullscreen
    if (el.classList.contains('fullscreen')) {
      return el.classList.remove('fullscreen')
    }
    el.classList.add('fullscreen')
  }

  onLoad() {
    this._loaderService.hide();
  }
}
